import { useEffect } from 'react';

type Props = {
  when?: boolean;
  onTryToUnload?: (isPreventing?: boolean) => void;
};

export const PreventUnload = ({ when = true, onTryToUnload }: Props) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      onTryToUnload?.(when);
      if (when) {
        event.preventDefault();
        event.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [when]);

  return null;
};
